// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AgreementsAndRules_wrapper__xiV_f","container":"AgreementsAndRules_container__2wksX","dot":"AgreementsAndRules_dot__3r_lg"};